<template lang="pug">
    div.card.has-equal-height
        div
            router-link(:to="button_link")
                p.is-size-5.has-text-weight-bold.topic-card-title {{title}}
        div.card-image
            figure.image-is4by3
                router-link(:to="button_link")
                    img(:src="image_name")
        div.card-content
            div.content {{content}}
        div.card-footer(v-if="has_link_button")
            div.card-footer-item
                router-link(:to="button_link")
                    a.button
                        strong {{button_text}}
</template>

<script>
export default {
    props: {
        title: String,
        image_name: String,
        content: String,
        has_link_button: Boolean,
        button_text: String,
        button_link: String,
    },
}
</script>

<style scoped>
.has-equal-height {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.has-equal-height .card-footer {
  margin-top: auto;
}

.topic-card-title {
    padding: 0.5rem;
    color: black;
}

.card {
    /* background-color: #E8E8E8; */
    background-color: #F0F0F0;
}

.button {
    background-color: transparent;
}
</style>
